import React from "react"
import styled from "styled-components"

const Buttn = (front, back) => {
  const [btn1, setBtn1] = React.useState(front)
  const [btn2, setBtn2] = React.useState(back)

  const timer = () => {
    setTimeout(() => {
      setBtn1(front)
      setBtn2(back)
    }, 5000)
  }
  function clearTimer() {
    clearTimeout(timer)
  }

  const toggleContactButton = e => {
    e.preventDefault()
    e.stopPropagation()
    setBtn1(back)
    setBtn2(front)
    clearTimer()
    timer()
  }

  const onHoverEnter = e => {
    e.stopPropagation()
    setBtn1(back)
    setBtn2(front)
  }
  const onHoverExit = e => {
    clearTimer()
    e.stopPropagation()
    setBtn1(front)
    setBtn2(back)
  }


  return (
    <ButtonContainer
      onClick={e => toggleContactButton(e)}
      onMouseEnter={onHoverEnter}
      onMouseLeave={onHoverExit}
    >
      <Btn>{btn1}</Btn>
      <Btn2>{btn2}</Btn2>
    </ButtonContainer>
  )
}

export default Buttn

const ButtonContainer = styled.div`
  transition: 0.8s cubic-bezier(0.775, 0.07, 0.575, 0.995);
  transform-style: preserve-3d;
  text-align: center;
`
const Btn = styled.div`
  cursor: pointer;
  width: 100%;
  height: 35px;
  background: #03989e;
  border: none;
  font-size: 1rem;
  color: #fff;
  backface-visibility: hidden;
  z-index: 2;
  transform: rotateX(0deg);
  position: absolute;
  border-radius: 0.5rem;
  padding-top: 0.1rem;

  // padding: 0.5rem 1rem;
`
const Btn2 = styled.div`
  cursor: pointer;
  width: 100%;
  height: 35px;
  background: #03989e;
  border: none;
  font-size: 1.5rem;
  color: #fff;
  backface-visibility: hidden;
  transform: rotateX(-180deg);
  position: relative;
  text-decoration: none;
  border-radius: 0.5rem;
  padding-top: 0.1rem;

  //padding: 0.5rem 1rem;
`
